import PhoneVerification from '../ui/PhoneVerification';
import P from '../../pages'
import { verifyHostPhoneNumber, updateHostPhoneNumber, skipSubmit } from '../../actions';
import { connect } from 'react-redux';

const mapStateToProps = (state, props) => 
  ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content,
    requiredFields: state.requiredFields,
    territory: state.territory
  });

const mapDispatchToProps = dispatch => ({
  onContinue(phoneMobile, verificationId, code) {
    dispatch(verifyHostPhoneNumber(phoneMobile, verificationId, code))
  },
  onSkipSubmit(payload) {
    dispatch(skipSubmit(payload));
  },
  updateHostPhoneNumber(phoneMobile) {
    return dispatch(updateHostPhoneNumber(phoneMobile));
  }
})

const Container = connect(mapStateToProps, mapDispatchToProps)(PhoneVerification);

export default Container;
